import {
  LoadFileDurationRef,
  LoadFileStepRef,
  LoadFileTypeRef,
  LoadFileUnitRef
} from '@/dto/scenario/load/LoadReference';
import { LoadFile } from '@/dto/scenario/load/LoadFile';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class LoadFileExt extends DtoExt {

  public static fromDto(dto: LoadFile): LoadFileExt {
    return new LoadFileExt({
      typeRef: dto.typeRef,
      durationRef: dto.durationRef,
      stepRef: dto.stepRef,
      unitRef: dto.unitRef,
      originalContent: dto.originalContent,
      startDate: DtoExt.localeDateFromUtc(dto.startDate),
      correctionCoefficient: dto.correctionCoefficient,
      name: dto.name,
      legacyContent: null
    } as any);
  }

  public typeRef: LoadFileTypeRef | null = null;
  public durationRef: LoadFileDurationRef | null = null;
  public unitRef: LoadFileUnitRef | null = null;
  public stepRef: LoadFileStepRef | null = null;
  public startDate: Date | null = null;
  public correctionCoefficient: number | null = 1;
  public name: string | null = null;
  public originalContent: string | null = null;

  constructor(options?: Partial<LoadFileExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): LoadFile {
    return new LoadFile({
      typeRef: this.typeRef,
      durationRef: this.durationRef,
      stepRef: this.stepRef,
      unitRef: this.unitRef,
      originalContent: this.originalContent,
      startDate: DtoExt.localeDateToUtc(this.startDate),
      correctionCoefficient: this.correctionCoefficient,
      name: this.name
    });
  }
}
